import { combineReducers } from 'redux';

// ================== Reducers ================== //
import purchaseInsurance from 'products/nomad_insurance/views/Purchase/reducer';
import hospitalSearch from 'products/nomad_insurance/views/HospitalSearch/state';
import planholder from './planholder';
import contract from './contract';
import groupMembers from './groupMembers';
import countries from './countries';
import offers from './offers';
import application from './application';
import referrals from './referrals';
import vouchers from './vouchers';

const nomadInsuranceReducer = combineReducers({
  planholder,
  contract,
  hospitalSearch,
  purchaseInsurance,
  groupMembers,
  countries,
  offers,
  application,
  referrals,
  vouchers
});

export default nomadInsuranceReducer;
